import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import './layout-consulta.css';
import FormularioConsulta from './formulario-consulta';
import { getNavigation } from '../../../redux/actions/application-actions';

class LayoutConsultaPaquete extends Component {
  componentDidMount() {
    this.props.actions.getNavigation();
  }

  render() {
    return (
      <div style={{ background: '#f3f3f3' }}>
        <div className='container formulario-consulta'>
          <div className='clearfix' />
          <div className='row'>
            <div className='col-lg-12'>
              <FormularioConsulta />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = function (store) {
  return {
    actualModule: store.applicationState.navigation.actualModule,
  };
};

const mapDispatchToProps = function (dispatch) {
  return {
    actions: bindActionCreators({ getNavigation }, dispatch),
  };
};

LayoutConsultaPaquete.propTypes = {
  actions: PropTypes.any,
};

export default connect(mapStateToProps, mapDispatchToProps)(LayoutConsultaPaquete);
